import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwUpdate } from '@angular/service-worker';
import { recargarSiCorresponde } from './recarga-error.handler';

const INACTIVIDAD_MS = 10 * 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class PwaService {
  public promptEvent: any;
  private versionNueva = false;

  constructor(
    private swUpdate: SwUpdate,
    private snackBar: MatSnackBar,
  ) {
    if (swUpdate.isEnabled) {
      // console.log('Service Worker Disponible');
      // Verifica si la app esta instalada
      window.addEventListener('beforeinstallprompt', (event) => {
        console.log('App no instalada');
        event.preventDefault();
        this.promptEvent = event;
      });
      // Verifica si hay nuevas versiones de la app cada X min
      const minutos = 1 * (1000 * 60);
      this.swUpdate.checkForUpdate();
      setInterval(() => {
        this.swUpdate.checkForUpdate();
      }, minutos);
      // Cuando hay una nueva version avisa para actualizar
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          this.avisarVersionNueva();
        }
      });
      // El SW ya no tiene los archivos de la versión con la que arrancó esta
      // pestaña: no hay nada que confirmar, sin recargar la app no sigue.
      this.swUpdate.unrecoverable.subscribe(() => recargarSiCorresponde());
    } else {
      console.log('Service Worker No Disponible');
    }
  }

  /**
   * Antes era un diálogo bloqueante: en una pantalla de sala que nadie toca
   * quedaba tapando la vista con la versión vieja. Ahora es un aviso que no tapa,
   * y si nadie usa la pantalla durante 10 min se aplica sola; con alguien
   * trabajando, espera a que deje de tocar.
   */
  private avisarVersionNueva() {
    if (this.versionNueva) return;
    this.versionNueva = true;
    this.snackBar
      .open('Hay una versión nueva', 'Recargar')
      .onAction()
      .subscribe(() => this.aplicarVersionNueva());
    let ultimoUso = Date.now();
    for (const ev of ['pointerdown', 'keydown', 'wheel']) {
      window.addEventListener(ev, () => (ultimoUso = Date.now()), {
        passive: true,
      });
    }
    setInterval(() => {
      if (Date.now() - ultimoUso >= INACTIVIDAD_MS) this.aplicarVersionNueva();
    }, 60_000);
  }

  private async aplicarVersionNueva() {
    // Sin activateUpdate() el SW sigue sirviendo la versión con la que arrancó
    // este cliente: el reload solo no aplica la nueva.
    await this.swUpdate.activateUpdate();
    window.location.reload();
  }

  public installPwa(): void {
    this.promptEvent.prompt();
    this.promptEvent.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') {
        this.promptEvent = null;
      }
    });
  }
}
